import React from 'react';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';
import IconComponent from '../../../shared/IconComponents/IconComponent';
import { TextCustom } from '../../../ui/TextCustom';

interface ICustomNodeLeftInfoProps {
    iconName: string;
    label: string;
}

export const CustomNodeLeftInfo: React.FC<ICustomNodeLeftInfoProps> = ({ iconName, label }) => {
    return (
        <FlexCenter direction="v" position="center">
            <IconComponent size={1.6} iconName={iconName} />

            <TextCustom color="dark" weight={700}>
                {label}:
            </TextCustom>
        </FlexCenter>
    );
};
